import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["fill"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3 29H45V34C45 35.6569 43.6569 37 42 37H6C4.34314 37 3 35.6569 3 34V29Z",
  fill: "#EAECF0",
  stroke: "#475467",
  "stroke-width": "2"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3 14H45V26H3V14Z",
  fill: "#EAECF0",
  stroke: "#EAECF0",
  "stroke-width": "2"
}, null, -1)
const _hoisted_4 = ["stroke"]
const _hoisted_5 = ["stroke"]
const _hoisted_6 = ["stroke"]
const _hoisted_7 = ["stroke"]


export default /*#__PURE__*/_defineComponent({
  __name: 'FooterIcon',
  props: {
  fillColor: {
    type: String,
    required: false,
    default: 'white',
  },
  strokeColor: {
    type: String,
    required: false,
    default: 'white',
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: __props.fillColor,
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("line", {
      x1: "8",
      y1: "22",
      x2: "15",
      y2: "22",
      stroke: __props.strokeColor,
      "stroke-width": "2",
      "stroke-linecap": "round"
    }, null, 8, _hoisted_4),
    _createElementVNode("line", {
      x1: "8",
      y1: "18",
      x2: "32",
      y2: "18",
      stroke: __props.strokeColor,
      "stroke-width": "2",
      "stroke-linecap": "round"
    }, null, 8, _hoisted_5),
    _createElementVNode("line", {
      x1: "13",
      y1: "33",
      x2: "20",
      y2: "33",
      stroke: __props.strokeColor,
      "stroke-width": "2",
      "stroke-linecap": "round"
    }, null, 8, _hoisted_6),
    _createElementVNode("line", {
      x1: "8",
      y1: "33",
      x2: "9",
      y2: "33",
      stroke: __props.strokeColor,
      "stroke-width": "2",
      "stroke-linecap": "round"
    }, null, 8, _hoisted_7)
  ], 8, _hoisted_1))
}
}

})